import React from 'react';
import Main from 'views/layouts/Main/Main';

import { AllParentSupport } from './AllParentSupport';

const ParentEd = () => {
	return (
		<Main sx={{ boxShadow: 0 }}>
			<AllParentSupport />
		</Main>
	);
};

export default ParentEd;
